import React, { Component } from 'react';
import { connect } from 'react-redux';
import {getSupplierInvoicesCountByUtilityPerMonth, getSitesSupplierInvoices} from "../../api";
import { Grid } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import SupplierTableHeader from "../supplier-invoices/supplier-table-header";
import SupplierTableRow from "../supplier-invoices/supplier-table-row";
import {DateFilterSupplierInvoices} from "../../components/table/filters/date-filter-supplierinvoices";
import {collateUtilityData} from "../../helpers/chart-dataset-helpers";
import ApiDataProvider from "../../components/table/data-providers/api-data-provider";
import FilterableDatatable from "../../components/table/filterable-data-table";
import ReactGA from 'react-ga';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom'; // Import withRouter HOC for programmatic navigation


function mapStateToProps(state) {
    return {

    };
}

function mapDispatchToProps(dispatch, ownProps) {
    return {

    };
}



class SupplierInvoices extends Component {

    constructor(props)
    {
        super(props);

        this.state = {
            dataProvider: new ApiDataProvider(getSitesSupplierInvoices, [this.props.customerId, this.props.siteKey]),
            countData: {},
            nettCostData: {},
            filterValue: "", // This state will hold the filter value

        }
    }

    
handleQueryParamsChange() {
    const queryParams = queryString.parse(this.props.location.search);
    const initialSupply = queryParams.utility;
    const initialDate = queryParams.date;
  
    // Assuming you have a method to update the component's state or fetch new data based on these parameters
    this.setState({
      supplyOverride: initialSupply,
      initialDate: initialDate,
    });
  
    this.fetchData(initialSupply); 
  
    // Any other actions that need to be performed when query params change
  }

  
  componentDidUpdate(prevProps) {
    // Check if the URL's query parameters have changed
    if (this.props.location.search !== prevProps.location.search) {
      this.handleQueryParamsChange();
    }

  }

  
  componentDidMount() {

    this.handleQueryParamsChange();

    const queryParams = queryString.parse(this.props.location.search);
    const initialSupply = queryParams.utility; // Assuming date is passed as "YYYY-MM-DD"
    const initialDate = queryParams.date; // Assuming date is passed as "YYYY-MM-DD"

    var status = initialSupply//"Gas"

    if(initialSupply)
    {

    this.filterableDataTableRef.onAdvancedFilterChange({
        name: "Utility",
        value: status
    });

    this.setState({
        supplyOverride: status,
        initialDate : initialDate
    })
   


        this.fetchData(status); 
    }

    

        ReactGA.pageview('site supplier invoices tab');

}


    updateFilterValue = (newFilterValue) => {
        
        // Assuming you store the filter value in state like this:
        this.setState({ filterValue: newFilterValue });
    };

    
    // Method to update supplierOverride
    updateSupplierOverride = (newSupplierOverride) => {
        this.setState({ supplierOverride: newSupplierOverride }, () => {
            // Optionally, perform additional actions here
            //this.fetchData(newSupplierOverride);
            this.filterableDataTableRef.onAdvancedFilterChange({
                name: "Supplier",
                value: newSupplierOverride
            });
        });
    };

    removeUtilityParams = (search) => {
        const params = new URLSearchParams(search);
        const utilities = ['electricity', 'gas', 'water']; // Add any other utility types as needed
    
        utilities.forEach(utility => {
            if (params.has('utility') && params.get('utility').toLowerCase() === utility) {
                params.delete('utility');
            }
        });
    
        return params.toString();
    };

    // Inside SupplierInvoices component
    updateSupplyOverride = (newSupplyOverride) => {

        const cleanedSearch = this.removeUtilityParams(this.props.location.search);

        if (cleanedSearch !== this.props.location.search) {
            this.props.history.replace({
                pathname: this.props.location.pathname,
                search: cleanedSearch
            });
        }

        this.setState({ supplyOverride: newSupplyOverride }, () => {
        // You can perform additional actions here if needed, such as refreshing data
        this.fetchData(newSupplyOverride);
    });
    };

    trimGraphDates = (toDate, fromDate) => {
     
        this.props.trimSiteGraphDates(toDate,fromDate)
    
        // const trimmedCountData = this.trimGraphData(this.state.initialCountData, toDate, fromDate);
        // const trimmedNettCostData = this.trimGraphData(this.state.initialNettCostData, toDate, fromDate);
    
        // // Update the state with the trimmed data
        // this.setState({
        //     countData: trimmedCountData,
        //     nettCostData: trimmedNettCostData
        // });
    };
    

    fetchData = (status) => {
        getSupplierInvoicesCountByUtilityPerMonth(this.props.customerId)
            .then((utilityData) => {
                this.setState({ countData: collateUtilityData(utilityData, "count"),
                    nettCostData: collateUtilityData(utilityData, "nettCost") }
           
                    
                    , () => {
                        // This callback ensures that filters are applied after state is updated
                        if(status !== "" && status !== undefined) {
                            this.filterableDataTableRef.onAdvancedFilterChange({
                                name: "Utility",
                                value: status
                            });
                        }
                    })


                    
            });
    }

    render() {
        return (
            <div className="main-container">
               
                <Grid padded stackable columns='equal'>
                <Grid.Row>
                        <Grid.Column>
                            <div className="table-container">
                                <FilterableDatatable dataProvider={this.state.dataProvider} 
                                name="supplier-invoices"
                                ref={(ref) => (this.filterableDataTableRef = ref)}  
                                canExport={true}
                                filterComponent={DateFilterSupplierInvoices} 
                                filterComponentProps={{
                                    initialDate: this.state.initialDate, // Make sure this is passed correctly
                                    filter: this.state.filterValue, // Pass the filter value to DateFilterSupplierInvoices
                                    filterValue: this.state.filterValue, // Ensure you are passing this
                                    updateSupplyOverride: this.updateSupplyOverride, // Pass the callback here
                                    updateSupplierOverride: this.updateSupplierOverride, // New callback 
                                    trimGraphDates : this.trimGraphDates
                                }}
                                                    supplierOverride={this.state.supplierOverride}

                                                     supplyOverride={this.state.supplyOverride}
                                                     initialDate= {this.state.initialDate} // Ensure this is correctly derived and passed down                                                    

                                                     contextData={{
                                                        customerId: this.props.customerId,
                                                        updateSupplyOverride: this.updateSupplyOverride, // Pass the callback here
                                                        updateSupplierOverride: this.updateSupplierOverride, // New callback 
                                                        updateFilterValue: this.updateFilterValue, // Pass the method down
                                                    }}
                                                     headerComponent={SupplierTableHeader} rowComponent={SupplierTableRow} />
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}

const wrap = connect(mapStateToProps, mapDispatchToProps);
export default withRouter(wrap(SupplierInvoices));